import ImportWizard from "@components/content/ImportWizard";
import { clientImportDefinition } from "@utils/import/definitions/clientImport";

const ClientImport = () => <ImportWizard definition={clientImportDefinition} />;

export default ClientImport;
